module.exports = __webpack_public_path__ + "images/b583f81c886f4e05f96336862ff0c3a8af75dda69ed99461042624a4529f1586.svg";